<template>
  <div>
    <Alert show-icon type="error" v-if="error">{{ errorMsg }}</Alert>
    <Alert show-icon v-if="!active && !checkActiveLoading" type="warning">
      当前账号未激活/激活失效
      <Icon type="ios-bulb-outline" slot="icon"></Icon>
      <template slot="desc">请联系管理员激活</template>
      <a style="float: right" v-on:click="checkActive">刷新</a>
    </Alert>
    <Alert show-icon v-else-if="!not_project && !getUserProjectLoading" type="warning">
      当前账号未授权任何租户
      <Icon type="ios-bulb-outline" slot="icon"></Icon>
      <template slot="desc">请联系管理员分配租户</template>
      <a style="float: right" v-on:click="checkActive">刷新</a>
    </Alert>
    <Card shadow :class="{'private-cloud-menu-main': true, 'private-cloud-menu-main-tran': $route.name === 'privateCloudMain'}">
      <Spin fix v-if="checkActiveLoading || getUserProjectLoading"></Spin>
      <div v-if="expand || $route.name === 'privateCloudMain'" style="padding: 16px">
        <Row v-if="$route.name !== 'privateCloudMain'">
          <a v-on:click="expand = !expand" style="float: right;">
            <Icon type="md-arrow-dropup-circle" size="27"/>
          </a>
        </Row>
        <Row class="private-cloud-menu" v-for="(menuItem, menuIndex) in menu" :key="`menuItem_${menuIndex}`">
          <div v-for="(item, index) in menuItem.menus" :key="index" v-if="(item.superuser_menu && $store.state.user.superuser) || (!item.superuser_menu)">
            <Card :class="{'private-cloud-menu-card': true, 'private-cloud-menu-card-active': item.router && item.router.name === $route.name }"
                  v-if="(active) || (item.is_active && active) || (!item.is_active && $store.state.user.superuser)">
              <div v-on:click="pushRouter(item)" class="private-cloud-menu-card-content">
                <Icon :type="item.icon" class="icon-iconfont" size="70" :color="item.color"/>
                <p class="private-cloud-menu-card-title">{{ item.title }}</p>
              </div>
            </Card>
          </div>
        </Row>
      </div>
      <Row v-else>
        <Menu mode="horizontal" :active-name="$route.name" class="private-cloud-menu-strip" @on-select="selectMenu">
          <div style="position: absolute; left: 10px; border-right: 1px solid #F5F7F9">
            <span>租户：</span>
            <Select v-model="selectedProject" style="width: 100px; padding-right: 10px" transfer size="small">
              <Option v-for="item in projects" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </div>
          <div style="padding-left: 140px; padding-right: 20px;">
            <Spin fix v-if="checkActiveLoading || getUserProjectLoading"></Spin>
            <div v-for="(menuItem, menuIndex) in menu" :key="`menuItem_${menuIndex}`">
              <div v-for="(item, index) in menuItem.menus" :key="index" v-if="(item.router) && (item.superuser_menu && $store.state.user.superuser) || (!item.superuser_menu)">
                <MenuItem :name="item.router.name" v-if="(active) || (item.is_active && active) || (!item.is_active && $store.state.user.superuser)">
                  <Icon :type="item.icon" class="icon-iconfont" size="15" :color="item.color"/>
                  {{ item.title }}
                </MenuItem>
              </div>
            </div>
          </div>
          <div style="position: absolute; right: 10px;">
            <a v-on:click="expand = !expand">
              <Icon type="md-apps" size="27" style="line-height: 60px;" />
            </a>
          </div>
        </Menu>
      </Row>
    </Card>
  </div>
</template>

<script>
import { getPrivateCloudUserProjects, checkPrivateCloudSelfActive } from '@/api/private-cloud/user'
import { getCacheData } from '@/api/private-cloud/general'
import { mapActions } from 'vuex'

export default {
  name: 'private_cloud_menu',
  data () {
    return {
      expand: false,
      menu: [
        {
          menus: [
            {
              title: '资源概况',
              icon: 'iconfont icon-dashboard',
              color: '#666699',
              router: {
                name: 'private_cloud_resource_overview'
              },
              superuser_menu: false,
              is_active: false
            }
            // {
            //   title: '硬件监控',
            //   icon: 'iconfont icon-xingnengjiankong-Filledbianma',
            //   color: '#FF9966',
            //   router: {
            //     name: ''
            //   },
            //   superuser_menu: false,
            //   is_active: false
            // }
          ]
        },
        {
          menus: [
            {
              title: '主机列表',
              icon: 'iconfont icon-server',
              color: '#19be6b',
              router: {
                name: 'server'
              },
              superuser_menu: false,
              is_active: true
            },
            {
              title: '镜像',
              icon: 'iconfont icon-image',
              color: '#2db7f5',
              router: {
                name: 'image'
              },
              superuser_menu: false,
              is_active: true
            },
            {
              title: '密钥对',
              icon: 'iconfont icon-keypairs',
              color: '#ff9900',
              router: {
                name: 'keyPairs'
              },
              superuser_menu: false,
              is_active: true
            },
            {
              title: '实例类型',
              icon: 'iconfont icon-type',
              color: '#5cadff',
              router: {
                name: 'flavor'
              },
              superuser_menu: false,
              is_active: true
            }
          ]
        },
        {
          menus: [
            {
              title: '虚拟网络',
              icon: 'iconfont icon-network1',
              color: '#CC99CC',
              router: {
                name: 'network'
              },
              superuser_menu: false,
              is_active: true
            },
            {
              title: '虚拟路由',
              icon: 'iconfont icon-router',
              color: '#CCCC99',
              router: {
                name: 'route'
              },
              superuser_menu: false,
              is_active: true
            },
            {
              title: '浮动IP',
              icon: 'iconfont icon-floating-ip',
              color: '#669999',
              router: {
                name: 'floatingIps'
              },
              superuser_menu: false,
              is_active: true
            },
            {
              title: '安全组',
              icon: 'iconfont icon-SecurityGroupmem-W',
              color: '#ff9900',
              router: {
                name: 'securityGroups'
              },
              superuser_menu: false,
              is_active: true
            }
          ]
        },
        {
          menus: [
            {
              title: '云硬盘',
              icon: 'iconfont icon-storage',
              color: '#66CCCC',
              router: {
                name: 'volumes'
              },
              superuser_menu: false,
              is_active: true
            },
            {
              title: '快照',
              icon: 'iconfont icon-snapshot',
              color: '#6666CC',
              router: {
                name: 'snapshots'
              },
              superuser_menu: false,
              is_active: true
            },
            {
              title: '备份',
              icon: 'iconfont icon-m_backup',
              color: '#99CCCC',
              router: {
                name: 'backups'
              },
              superuser_menu: false,
              is_active: true
            }
          ]
        },
        {
          menus: [
            {
              title: '租户',
              icon: 'iconfont icon-app',
              color: '#666699',
              router: {
                name: 'private_cloud_project'
              },
              superuser_menu: true,
              is_active: false
            },
            {
              title: '角色',
              icon: 'iconfont icon-role',
              color: '#FFCC99',
              router: {
                name: 'private_cloud_role'
              },
              superuser_menu: true,
              is_active: false
            },
            {
              title: '区域',
              icon: 'iconfont icon-node',
              color: '#6699CC',
              router: {
                name: 'private_cloud_availability_zone'
              },
              superuser_menu: true,
              is_active: false
            },
            {
              title: '主机聚合',
              icon: 'iconfont icon-IDCjifang',
              color: '#5cadff',
              router: {
                name: 'private_cloud_aggregate'
              },
              superuser_menu: true,
              is_active: false
            },
            {
              title: '用户激活',
              icon: 'iconfont icon-set',
              color: '#9999FF',
              router: {
                name: 'private_cloud_user'
              },
              superuser_menu: true,
              is_active: false
            },
            {
              title: '系统配置',
              icon: 'iconfont icon-mzicon-setting',
              color: '#808695',
              router: {
                name: 'private_cloud_setting'
              },
              superuser_menu: true,
              is_active: false
            },
            {
              title: '操作日志',
              icon: 'iconfont icon-log',
              color: '#5cadff',
              router: {
                name: 'private_cloud_operate_log'
              },
              superuser_menu: false,
              is_active: false
            }
          ]
        }
      ],
      projects: [],
      userDefaultProject: '',
      selectedProject: '',
      active: false,
      not_project: true,
      error: false,
      errorMsg: null,
      checkActiveLoading: false,
      getUserProjectLoading: false,
      timer: null
    }
  },
  created: function () {
    this.init()
  },
  beforeDestroy () {
    this.clearTimer()
  },
  watch: {
    '$store.state.user.defaultTenant' () {
      this.init()
      this.$router.push({name: 'privateCloudMain'})
    },
    selectedProject () {
      this.saveSelPrivateCloudProject(this.selectedProject)
      // this.$emit('projectChange')
      // if (this.selectedProject && this.$route.name === 'private_cloud_not_project') {
      //   this.$router.push({name: 'privateCloudMain'})
      // }
      this.$router.push({name: 'privateCloudMain'})
    }
  },
  methods: {
    ...mapActions([
      'saveSelPrivateCloudProject',
      'saveCacheData'
    ]),
    init () {
      this.projects = []
      this.selectedProject = ''
      this.checkActive()
      this.getCache()
      this.clearTimer()
      this.setTimer()
    },
    pushRouter (item) {
      if (item.router) {
        this.$router.push(item.router)
        this.expand = false
      }
    },
    selectMenu (name) {
      this.$router.push({name: name})
    },
    checkActive () {
      this.checkActiveLoading = true
      checkPrivateCloudSelfActive().then(res => {
        this.checkActiveLoading = false
        if (res.data.active) {
          this.active = true
          this.userDefaultProject = res.data.user.default_project_id
          this.getUserProject()
        } else {
          this.active = false
        }
      }).catch(res => {
        this.checkActiveLoading = false
        this.active = false
        console.error(res.response)
      })
    },
    getUserProject () {
      this.getUserProjectLoading = true
      getPrivateCloudUserProjects().then(res => {
        this.getUserProjectLoading = false
        this.projects = res.data
        this.error = false
        this.not_project = !!this.projects.length
        let validDefaultProject = false
        if (this.projects.length) {
          if (this.$store.state.privateCloud.selPrivateCloudProject) {
            for (let i in this.projects) {
              if (this.$store.state.privateCloud.selPrivateCloudProject === this.projects[i].id) {
                this.selectedProject = this.$store.state.privateCloud.selPrivateCloudProject
                validDefaultProject = true
                break
              }
            }
          }
          if (!validDefaultProject && this.userDefaultProject) {
            for (let i in this.projects) {
              if (this.userDefaultProject === this.projects[i].id) {
                this.selectedProject = this.userDefaultProject
                validDefaultProject = true
                break
              }
            }
          }
          if (!validDefaultProject) {
            this.selectedProject = this.projects[0].id
          }
        }
      }).catch(res => {
        this.getUserProjectLoading = false
        console.error(res.response)
        this.error = true
        this.errorMsg = res.response.data
      })
    },
    getCache () {
      getCacheData().then(res => {
        this.saveCacheData(res.data)
      }).catch(res => {
        console.error(res.response)
      })
    },
    // 定时请求
    setTimer () {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.getCache(false)
        }, 180000)
      }
    },
    // 清除定时器
    clearTimer () {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
</script>

<style lang="less">
  .private-cloud-menu-main-tran {
    background: unset;
  }
  .private-cloud-menu-main {
    margin-bottom: 5px;
    padding: 0;
    .ivu-card-body {
      padding: 0;
    }
    .private-cloud-menu {
      .private-cloud-menu-card {
        width: 130px;
        height: 130px;
        text-align: center;
        float: left;
        margin: 15px;
        .private-cloud-menu-card-content {
          padding: 16px;
          cursor: pointer;
          width: 130px;
          height: 130px;
        }
        .ivu-card-body {
          padding: 0;
        }
        .private-cloud-menu-card-title {
          position: relative;
          bottom: -10px;
        }
      }
      .private-cloud-menu-card-active {
        border-color: #2db7f5;
        border-bottom: 2px #2d8cf0 solid;
        .private-cloud-menu-card-title {
          color: #2d8cf0
        }
      }
      .private-cloud-menu-card:hover {
        border-color: #2db7f5;
      }
    }
    .private-cloud-menu-strip {
      overflow-y: hidden;
    }
    .private-cloud-menu-strip:after {
      height: unset;
    }
  }
  .icon-iconfont {
    font-family: iconfont;
    text-align: center;
  }
</style>
